type PillDetailProps = {
  onClick?: () => any;
  copy?: string;
  color?: string;
  margin?: string;
  background?: string;
  padding?: string;
  textSize?: string;
  border?: string;
  borderRadius?: string;
  addClassStyles?: string;
};

export default function PillDetail({
  onClick,
  copy,
  color = '',
  margin = 'mr-0.8 mb-0.8',
  background = '',
  padding = 'px-0.8 py-0.4',
  textSize = 'text-xs',
  border = 'border border-black border-opacity-10',
  borderRadius = '',
  addClassStyles,
}: PillDetailProps) {
  return (
    <div
      onClick={onClick}
      className={`${border} ${margin} ${padding} ${textSize} ${color} text-center ${borderRadius} ${background} ${addClassStyles}`}
    >
      {copy}
    </div>
  );
}
